import { Directive, OnDestroy, OnInit } from '@angular/core';
import { NgControl } from '@angular/forms';
import { Subscription } from 'rxjs';

@Directive({
  standalone: true,
  selector: '[digitalPlatformPhoneFormat]',
})
export class PhoneFormatDirective implements OnInit, OnDestroy {
  private previous = '';
  private subscription: Subscription = new Subscription();

  constructor(private ngControl: NgControl) {}

  ngOnInit() {
    if (this.ngControl) {
      this.previous = this.ngControl.value || '';
      this.subscription =
        this.ngControl.valueChanges?.subscribe((data: string) =>
          this.onInputChange(data)
        ) || new Subscription();
    }
  }

  onInputChange(event: string) {
    if (!event || !this.ngControl) return;
    if (event === this.previous) return;

    let newVal = event.replace(/\D/g, '');

    if (event.length < this.previous.length) {
      const lastChar = this.previous.substring(this.previous.length - 1);
      if (/\D/.test(lastChar)) {
        newVal = newVal.substring(0, newVal.length - 1);
      }
    }

    let formatted: string;
    if (newVal.length === 0) {
      formatted = '';
    } else if (newVal.length <= 3) {
      formatted = newVal;
    } else if (newVal.length <= 6) {
      formatted = newVal.slice(0, 3) + '-' + newVal.slice(3, 6);
    } else if (newVal.length <= 10) {
      formatted =
        newVal.slice(0, 3) +
        '-' +
        newVal.slice(3, 6) +
        '-' +
        newVal.slice(6, 10);
    } else {
      newVal = newVal.substring(0, 10);
      formatted =
        newVal.slice(0, 3) +
        '-' +
        newVal.slice(3, 6) +
        '-' +
        newVal.slice(6, 10);
    }

    // write formatted value to form control and store for next run
    this.ngControl.control?.setValue(formatted, { emitEvent: false });
    this.previous = formatted;
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }
}
